import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import _ from 'lodash';
import CategoryInput from './category-input.vue';
import { categoryConfig, isPresetOptionCategory } from '@/store/creative/common/category';
import { isHiddenCategory } from '@/views/creative/utils';

export default {
  props: {
    category: {
      type: Array,
      required: true
    },

    resource: {
      type: Object,
      required: true
    },

    activeCategoryId: {
      type: [Number, String],
      required: true
    },

    updateActiveCategoryId: {
      type: Function,
      required: true
    },

    updateActiveCategoryNode: [Function],

    validate: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    var _this = this;

    return {
      selectedNodeId: '',
      schema: {
        type: 'object',
        properties: {
          name: {
            component: CategoryInput,
            field: {
              placeholder: this.$t('playTurbo.creative.categorySearch.searchText'),
              selectWhenUnmatched: true,
              fetchSuggestions: function fetchSuggestions(queryString, cb) {
                var self = _this;
                queryString = queryString.trim().toLowerCase();

                var category = [];
                var rec = function rec(data) {
                  data.forEach(function (item) {
                    if (item.name && item.name.toLowerCase().indexOf(queryString) > -1) {
                      category.push(item);
                    } else if (item.sub_category) {
                      rec(item.sub_category);
                    }
                  });
                };
                rec(_.cloneDeep(self.category));

                if (category.length) {
                  cb(category.filter(function (item) {
                    return item.disabled !== true && item.visible !== false && item.pid !== categoryConfig.elementStars.id && item.pid !== categoryConfig.gameConfigStars.id && self.innerCategory.some(function (i) {
                      return i.id === item.id;
                    });
                  }).map(function (item) {
                    return _extends({
                      parent: self.innerCategory.find(function (el) {
                        return el.id === item.pid;
                      }),
                      value: item.name,
                      id: item.id
                    }, item);
                  }));
                } else {
                  cb([{
                    searchType: 'notmatch',
                    value: ''
                  }]);
                }
              },
              listeners: {
                select: function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
                    var valid;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.validate();

                          case 2:
                            valid = _context.sent;

                            if (!(node.searchType || !node.id)) {
                              _context.next = 5;
                              break;
                            }

                            return _context.abrupt('return');

                          case 5:
                            if (valid) {
                              _this.selectedNodeId = node.id;
                              _this.updateActiveCategoryNode(node);
                              _this.updateActiveCategoryId(node.id);
                            }

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function select(_x) {
                    return _ref.apply(this, arguments);
                  };
                }()
              }
            }
          }
        }
      },

      model: {
        name: ''
      }
    };
  },


  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    isCreativeTemplateCustom: function isCreativeTemplateCustom(state) {
      return state.creative.template.isCreativeTemplateCustom;
    }
  }), {
    innerCategory: function innerCategory() {
      var self = this;
      var category = [];
      var rec = function rec(data) {
        data.forEach(function (item) {
          var currentPresetValue = '';
          if (isPresetOptionCategory(item)) {
            currentPresetValue = self.templateConfig.json_config.presetConfig[item.properties.preset].value;
            if (currentPresetValue !== item.prefix) return;
          }
          if (!isHiddenCategory(item, self.isCreativeTemplateCustom)) {
            category.push(item);
            if (item.sub_category) {
              rec(item.sub_category);
            }
          }
        });
      };
      rec(this.category);
      return category;
    }
  }),

  watch: {
    activeCategoryId: function activeCategoryId(val) {
      if (val && val !== this.selectedNodeId && this.model.name !== '') {
        this.model.name = '';
        this.selectedNodeId = '';
      }
    }
  }
};